import { render } from "./Texto1.vue?vue&type=template&id=baf4e436"
import script from "./Texto1.vue?vue&type=script&lang=js"
export * from "./Texto1.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__